import { render, staticRenderFns } from "./SlideRealInvoice.vue?vue&type=template&id=7f836c3e"
import script from "./SlideRealInvoice.vue?vue&type=script&lang=js"
export * from "./SlideRealInvoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports